module.exports = __webpack_public_path__ + "media/images/official/company_mission-445ba5697a9bce596215f0b19d01ee3a.jpg";